import { segment, hotjar, appcues } from '@hotjar/tracking';
import type { Analytics, Context } from '../types';

interface CreateAnalytics {
  (): Analytics;
}

export const createAnalytics: CreateAnalytics = () => {
  const context: Context = {};
  const addContext: Analytics['addContext'] = (data) => {
    Object.assign(context, data);
  };

  const track: Analytics['track'] = (key, data) => segment.track(key, { ...context, ...data });
  const hjEvent: Analytics['hjEvent'] = (action) => hotjar.event(action);

  const showOnboarding: Analytics['showOnboarding'] = (id, options) => {
    const showOnce = options?.showOnce;
    appcues.showContent(id, showOnce);
  };

  return {
    addContext,
    track,
    hjEvent,
    showOnboarding,
  };
};
